import angular from 'angular';
import scenes from './scenes';
import importantDocuments from './importantDocuments';

export default angular
  .module('scenes.importantDocuments', [scenes])
  .component('importantDocuments', importantDocuments).name;
